<template>
  <button
      type="button"
      class="edit-button"
      :disabled="disabled"
      @click="$emit('click')">
    <i class="fa-solid fa-pen edit-button-icon"></i>
    <span class="edit-button-text">{{ label }}</span>
  </button>
</template>

<script setup>
import {computed, defineEmits, defineProps} from 'vue';
import {piniaCompanySettingsStore} from "@/store/piniaCompanySettingsStore";

const piniaCompanySettingsState = piniaCompanySettingsStore()
const companySettings = computed(() => piniaCompanySettingsState.companySettings)
const companyColor = computed(() => companySettings.value?.colorCode || '#15803d')

defineProps({
  label: {
    type: String,
    default: 'Bearbeiten'
  },
  disabled: {
    type: Boolean,
    default: false
  }
})

defineEmits(['click'])
</script>

<style scoped>
.edit-button {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: 1px solid v-bind(companyColor);
  color: v-bind(companyColor);
  background-color: transparent;
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  user-select: none;
}

.edit-button:hover:not(:disabled) {
  color: #ffffff;
  background-color: v-bind(companyColor);
}

.edit-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.edit-button-icon {
  font-size: 12px;
}

.edit-button-text {
  white-space: nowrap;
}
</style>
